export enum CrossAxisAlignment {
  start = 1,
  end,
  center,
  stretch,
  baseline,
}
